import React from "react";

/**
 * Alerts Icon Component
 * @description A bell icon representing alerts and notifications
 */
export const AlertsIcon: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.35953 20.6968H15.6408C15.4954 21.5571 15.0499 22.3381 14.3835 22.9013C13.7171 23.4644 12.8727 23.7734 12.0002 23.7734C11.1277 23.7734 10.2833 23.4644 9.6169 22.9013C8.95047 22.3381 8.50502 21.5571 8.35953 20.6968ZM12.0002 -0.226562C14.4484 -0.226562 16.7963 0.745974 18.5274 2.4771C20.2585 4.20823 21.2311 6.55614 21.2311 9.00432V13.9275L22.9763 17.8167C23.0557 17.9946 23.0893 18.1895 23.0742 18.3837C23.0591 18.5779 22.9957 18.7652 22.8899 18.9287C22.784 19.0922 22.6389 19.2266 22.4679 19.3198C22.2968 19.413 22.1052 19.462 21.9105 19.4623H2.09484C1.8998 19.4623 1.70786 19.4134 1.53651 19.3203C1.36516 19.2271 1.21984 19.0926 1.11378 18.9289C1.00771 18.7652 0.944282 18.5776 0.929256 18.3831C0.914231 18.1887 0.948089 17.9935 1.02775 17.8155L2.76931 13.9262V8.98832L2.77546 8.68062C2.85965 6.29026 3.86839 4.02589 5.58915 2.3646C7.30992 0.703298 9.60834 -0.22645 12.0002 -0.226562Z"
      fill="white"
    />
  </svg>
);

export default AlertsIcon;

